module.exports = __webpack_public_path__ + "img/tjfoot3.45403a90.jpg";